"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OperatorLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ramda = require("ramda");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _handlers = require("../../../../../../../../helpers/handlers");
var _config = require("../../../../../../../../services/config");
var _RenderWhen = _interopRequireDefault(require("../../../../../../../RenderWhen"));
var _withProps = _interopRequireDefault(require("../../../../../Offer/Buttons/components/BookingButton/withProps"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var OperatorLinkPure = function OperatorLinkPure(_ref) {
  var loading = _ref.loading,
    name = _ref.name,
    onClick = _ref.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t('OPERATOR_TITLE'), ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    onClick: (0, _handlers.handleWith)(_handlers.prevent, function () {
      return !loading && onClick();
    })
  }, name));
};
var operatorLinkEnhancer = (0, _ramda.compose)(_withProps.default, _react.memo);
var OperatorLinkWithBooking = operatorLinkEnhancer(OperatorLinkPure);
var OperatorLink = exports.OperatorLink = function OperatorLink(_ref2) {
  var countryID = _ref2.countryID,
    isBookingByOperator = _ref2.isBookingByOperator,
    logo = _ref2.logo,
    name = _ref2.name,
    offerID = _ref2.offerID,
    operatorID = _ref2.operatorID;
  var _useTranslation2 = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react.default.createElement(_RenderWhen.default, {
    isTrue: true
  }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: (0, _ramda.or)((0, _config.getIsEnableAdvertiseForOperatorsForce)(), isBookingByOperator && !(0, _config.isDisabledAdvertiseByOperator)(operatorID))
  }, /*#__PURE__*/_react.default.createElement(OperatorLinkWithBooking, {
    countryID: countryID,
    logo: logo,
    name: name,
    offerID: offerID
  })), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: true
  }, "".concat(t('OPERATOR_TITLE'), " ").concat(name)));
};
OperatorLink.propTypes = {
  countryID: _propTypes.default.number.isRequired,
  isBookingByOperator: _propTypes.default.bool.isRequired,
  logo: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  offerID: _propTypes.default.string.isRequired,
  operatorID: _propTypes.default.number.isRequired
};